import { render } from "./OpenInnovationMinorProject.vue?vue&type=template&id=72ad2430&scoped=true"
const script = {}

import "./OpenInnovationMinorProject.vue?vue&type=style&index=0&id=72ad2430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ad2430"]])

export default __exports__